// ~ import vue instance
import Vue from 'vue'
// ~ define our bus object
let eventBus = new Vue()
// ~ export bus for use in other components
export default eventBus



// WEBPACK FOOTER //
// ./src/EventBus.js